/**
 * Champ « retaper un texte exact pour confirmer » — recette commune à toute action
 * destructrice qui exige une preuve de lecture, pas seulement un clic (première utilisation :
 * suppression d'une organisation, `dialogs/DeleteOrganizationDialog.jsx`).
 *
 * Volontairement muet sur ce qu'il fait de la comparaison : c'est l'appelant qui décide si
 * `value === expected` doit être strict (le serveur ne fait confiance à personne pour cette
 * vérification — § spec suppression d'organisation) ou tolérer un `trim()`. Exporter
 * `typeToConfirmMatches` évite qu'un futur appelant réinvente sa propre règle.
 */

import { FORM_FIELD, FORM_LABEL, INPUT } from '../ui/theme.js';

/** Comparaison stricte, à l'octet — pas de `trim()` : le nom à retaper est celui affiché. */
export const typeToConfirmMatches = (value, expected) => value === expected;

export function TypeToConfirmField({ id, label, value, onChange, disabled = false }) {
  return (
    <label htmlFor={id} className={FORM_FIELD}>
      <span className={FORM_LABEL}>{label}</span>
      <input
        id={id}
        className={INPUT}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
        autoComplete="off"
        autoCorrect="off"
        spellCheck={false}
      />
    </label>
  );
}
